//export const API_URL = 'http://localhost:8008/api';
export const API_URL = 'https://mdzaar.ebslab.in/api';
export const API_URL_AUTH = 'https://auth.ebslab.in/api';
